import script from "./PaymentsPageCreatorPayoutsTabV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentsPageCreatorPayoutsTabV2.vue?vue&type=script&setup=true&lang=js"

import "./PaymentsPageCreatorPayoutsTabV2.vue?vue&type=style&index=0&id=18081c92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18081c92"]])

export default __exports__